import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable camelcase */
import { useEffect } from 'react';
import { Component, ContextType, DropInPaymentsCommandNames, fireStatusUpdate, Namespace, StatusTypes, ErrorType, ValidationManager, consolidateApolloErrors, ProductType } from '@chegg/commerce-utils';
import { sendPurchaseEvent } from '../utils/OptimizelyWebUtils';
import useCreatePurchase from './useCreatePurchase';
import { useAppSelector } from './useAppSelector';
import { cartSelector } from '../redux/cart/cart.selectors';
import { fraudSelector } from '../redux/fraud/fraud.selectors';
import { useDispatch } from 'react-redux';
import { clearCartInfo, saveCartInfo } from '../redux/cart/cart.slice';
import { clearMessage, showMessage } from '../redux/message/message.slice';
import { ERRORS } from '../constants/Errors';
import { MessageType } from '../redux/message/message.types';
import { sendNewRelicMessage } from '../utils/NewRelicUtils';
import { LogRioPurchaseEvent } from '../utils/RecurlyRioPurchaseEvent';
import { configSelector } from '../redux/config/config.selectors';
var getMopError = ValidationManager.ValidationMessages.getMopError;
var firePlaceOrderPendingStatusUpdate = function firePlaceOrderPendingStatusUpdate() {
  fireStatusUpdate([{
    status: StatusTypes.PENDING,
    command: DropInPaymentsCommandNames.PLACE_ORDER,
    payload: {
      component: Component.CART_CHECKOUT,
      context: ContextType.DROP_IN_PAYMENTS
    }
  }], Namespace.DROP_IN_PAYMENTS);
};
var firePlaceOrderSuccessStatusUpdate = function firePlaceOrderSuccessStatusUpdate(cartId, subscriptionId) {
  fireStatusUpdate([{
    status: StatusTypes.SUCCESS,
    command: DropInPaymentsCommandNames.PLACE_ORDER,
    payload: {
      component: Component.CART_CHECKOUT,
      context: ContextType.DROP_IN_PAYMENTS,
      data: {
        cartId: cartId,
        token: subscriptionId,
        orderKey: subscriptionId
      }
    }
  }], Namespace.DROP_IN_PAYMENTS);
};
var getCommerceErrors = function getCommerceErrors(graphQLErrors) {
  return graphQLErrors.map(function (error) {
    var _ref = error.extensions.chegg ? error.extensions.chegg : error.extensions,
      code = _ref.code,
      details = _ref.details;
    // Transform RCLY error code to pmt
    // Transforming to avoid updating a lot of error handling logic build for legacy
    // m
    var clientSideCodeMapping = code === 'RCLY-31005' ? code : code.replace('RCLY-', 'pmt');
    return {
      code: clientSideCodeMapping,
      type: ErrorType.SERVER,
      details: details
    };
  });
};
var useRecurlyCheckout = function useRecurlyCheckout() {
  var dispatch = useDispatch();
  var cart = useAppSelector(cartSelector);
  var _useAppSelector = useAppSelector(fraudSelector),
    forterToken = _useAppSelector.forterToken;
  var billingAddress = cart.billingAddress,
    billingInfoId = cart.billingInfoId,
    planCode = cart.externalId,
    cartId = cart.cartId,
    tokenId = cart.tokenId,
    items = cart.items;
  var _useAppSelector2 = useAppSelector(configSelector),
    rioNamespace = _useAppSelector2.rioNamespace,
    isCouponVerified = _useAppSelector2.isCouponVerified,
    couponCode = _useAppSelector2.couponCode,
    coupon = _useAppSelector2.coupon;
  var _useCreatePurchase = useCreatePurchase(),
    createPurchase = _useCreatePurchase.createPurchase,
    createPurchaseData = _useCreatePurchase.createPurchaseData,
    createPurchaseError = _useCreatePurchase.createPurchaseError;
  var handlePurchaseSuccess = function handlePurchaseSuccess(data) {
    var familyProductTypeMap = new Map([['chegg_study', ProductType.CHEGG_STUDY], ['chegg_study_pack', ProductType.CHEGG_STUDY_PACK]]);
    var subscriptionId = data.createPurchase.subscription.id;
    var subscriptionFamily = data.createPurchase.subscription.vendorPlan.family;
    var productType = familyProductTypeMap.get(subscriptionFamily);
    LogRioPurchaseEvent(data, cart, rioNamespace);
    firePlaceOrderSuccessStatusUpdate(cartId, subscriptionId);
    void sendPurchaseEvent(productType);
    dispatch(clearCartInfo());
    dispatch(clearMessage());
  };
  var handlePurchaseError = function handlePurchaseError(graphQLErrors) {
    var errors = graphQLErrors && getCommerceErrors(graphQLErrors);
    var _getMopError = getMopError(errors === null || errors === void 0 ? void 0 : errors[0].code),
      message_detail = _getMopError.message_detail,
      message_id = _getMopError.message_id;
    sendNewRelicMessage('Recurly Order placement failed', {
      errors: "".concat(JSON.stringify(errors))
    });
    dispatch(showMessage({
      text: message_detail || ERRORS.GENERIC_FAILURE_ERROR.message,
      messageType: MessageType.ERROR
    }));
    dispatch(saveCartInfo({
      isCheckoutPending: false
    }));
    fireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: DropInPaymentsCommandNames.PLACE_ORDER,
      payload: {
        component: Component.CART_CHECKOUT,
        context: ContextType.DROP_IN_PAYMENTS,
        errors: [{
          code: message_id,
          message: message_detail,
          type: errors === null || errors === void 0 ? void 0 : errors[0].type
        }]
      }
    }], Namespace.DROP_IN_PAYMENTS);
  };
  var initializeCheckout = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            firePlaceOrderPendingStatusUpdate();
            void createPurchase({
              variables: {
                createPurchaseInput: _objectSpread({
                  billingAddress: billingAddress,
                  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                  currency: items === null || items === void 0 ? void 0 : items[0].pricingId,
                  planCode: planCode,
                  promotionCode: couponCode && (isCouponVerified || coupon.addCouponStatus == 'SUCCESS') ? [couponCode] : undefined,
                  fraudVendorToken: forterToken
                }, !!billingInfoId ? {
                  billingInfoId: billingInfoId
                } : {
                  createMethodOfPaymentInput: {
                    recurlyBillingInfo: {
                      tokenId: tokenId
                    }
                  }
                })
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function initializeCheckout() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (createPurchaseData !== null && createPurchaseData !== void 0 && createPurchaseData.createPurchase.subscription.id) {
      handlePurchaseSuccess(createPurchaseData);
    }
  }, [createPurchaseData]);
  useEffect(function () {
    if (createPurchaseError !== null && createPurchaseError !== void 0 && createPurchaseError.graphQLErrors || createPurchaseError !== null && createPurchaseError !== void 0 && createPurchaseError.networkError) {
      var allErrors = consolidateApolloErrors(createPurchaseError);
      handlePurchaseError(allErrors);
    }
  }, [createPurchaseError]);
  useEffect(function () {
    if (billingAddress && (billingInfoId || tokenId)) {
      void initializeCheckout();
    }
  }, [billingAddress, billingInfoId, tokenId]);
};
export default useRecurlyCheckout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/hooks/useRecurlyCheckout.js
// module id = 4670
// module chunks = 11